import React, { useContext, useEffect, useState } from "react";
import { Tooltip } from "antd";
import { QuestionCircleOutlined } from '@ant-design/icons'
import GeneralContext from "../../context/GeneralContext/GeneralContext";
import styles from "../../services/styles"
import DashboardFilters from "./DashboardFilters";
import PatientsByDentistGraph from "./PatientsByDentistGraph";
import moment from "moment";
import api from "../../services/api";
import { displayMessage } from "../../services/helper";
import ActivePatientsHoursGraph from "./ActivePatientsHoursGraph";


const { tc1 } = styles

export default function AdministratorDashboard(props) {


    const { mobile_mode, setShowLoading, user } = useContext(GeneralContext);

    const end_date = moment().format('YYYY-MM-DD');
    const start_date = moment(end_date).subtract(7, 'days').format('YYYY-MM-DD');

    const [patientsByDentistData, setPatientsByDentistsData] = useState([]);
    const [activePatientsHourData, setActivePatientsHourData] = useState([]);

    useEffect(() => {
        setShowLoading(true);
        //sempre que abria a tela estava sobrecarregando o servidor
        setShowLoading(false);
    }, [])

    const loadAllData = async () => {
        await loadPatientsByDentistData({ start_date, end_date });
        await loadActivePatientsHourData({ start_date, end_date });
    }

    const loadPatientsByDentistData = async (currentFilters) => {
        try {
            const payload = { ...currentFilters, id: user.id };
            const { data } = await api.administrator_dashboard.findDentistsWithPatients(payload);
            setPatientsByDentistsData(data);
        } catch (error) {
            console.log(error);
        }
    }

    const loadActivePatientsHourData = async (currentFilters) => {
        try {
            const payload = { ...currentFilters, id: user.id };
            const { data } = await api.administrator_dashboard.findActivePatientsHour(payload);
            setActivePatientsHourData(data.hoursCount);

            if (!data.has_data) {
                alert(displayMessage('NO_REGISTER_TO_PATIENTS_BY_HOUR_FOUND'))
            }
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <>
            <div
                style={{ color: tc1, fontWeight: "bold", marginBottom: 15, fontSize: mobile_mode ? 11 : 24 }}>
            </div>

            <DashboardFilters
                loadPatientsByDentistData={loadPatientsByDentistData}
                loadActivePatientsHourData={loadActivePatientsHourData}
                end_date={end_date}
                start_date={start_date}
            ></DashboardFilters>
            <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%', height: '100%', justifyContent: 'center' }}>
                <div style={{ display: 'flex', width: '95%', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ marginLeft: 'auto', marginRight: 'auto', fontSize: 20, }}>
                        {displayMessage("PATIENTS_BY_DENTIST")}
                    </div>
                    <div>
                        <Tooltip
                            placement="left"
                            color={tc1}
                            title={displayMessage('SOON_EXPLANATIONS')}>
                            <span style={{ fontSize: '20px' }}><QuestionCircleOutlined style={{ color: '#1052B4' }} /></span>
                        </Tooltip>
                    </div>
                </div>
                <div style={{
                    display: 'flex',
                    width: mobile_mode ? '100%' : '95%',
                    alignItems: 'center',
                }}>

                    <PatientsByDentistGraph patientsByDentistData={patientsByDentistData} />

                </div>
                <div style={{ display: 'flex', width: '95%', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ marginLeft: 'auto', marginRight: 'auto', fontSize: 20, }}>
                        {displayMessage("DISTRIBUTION_PATIENTS_PER_HOUR")}
                    </div>
                    <div>
                        <Tooltip
                            placement="left"
                            color={tc1}
                            title={displayMessage('SOON_EXPLANATIONS')}>
                            <span style={{ fontSize: '20px' }}><QuestionCircleOutlined style={{ color: '#1052B4' }} /></span>
                        </Tooltip>
                    </div>
                </div>
                <div style={{
                    display: 'flex',
                    width: mobile_mode ? '100%' : '95%',
                    alignItems: 'center',
                }}>
                    <ActivePatientsHoursGraph activePatientsHourData={activePatientsHourData} />
                </div>
            </div>
        </>
    )
}